<common-header [title]="title" [items]="items"></common-header>

<div *ngIf="loadpage"></div>
<app-handpay-voucher-list [isReport]="false" [idTurn]="idTurn"></app-handpay-voucher-list>
